module.exports = __webpack_public_path__ + "static/media/AccountActivatedPhone.4b44bdb0.svg";